import { z } from "zod";
import { confirmableConfig, confirmableDefaults } from "./confirmable.js";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  ...confirmableConfig,
  min: z.number().optional(),
  max: z.number().optional(),
  step: z.number().positive().default(1),
});

export const numberField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "number",
  label: "Number",
  category: "number",
  icon: "Hash",
  configSchema,
  valueSchema: (config, isRequired) => {
    let schema = z.number({ invalid_type_error: "Enter a number" }).int("Enter a whole number");
    if (config.min !== undefined) schema = schema.min(config.min);
    if (config.max !== undefined) schema = schema.max(config.max);
    return optionalUnlessRequired(schema, isRequired);
  },
  defaultConfig: { ...confirmableDefaults, step: 1 },
  supportsProfileBinding: true,
  defaultSearchable: false,
  sortKind: "numeric",
  renderHints: {},
};
